// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__2ex9J","errors":"Errors_errors__3syXq"};